<template>
<div>
    <div id="hotwater" class="wrapper">
        <!-- 内容は以下に記述して下さい。 -->
        <!-- 給湯 -->
        <app-error-list />
        <app-section>
            <h3 slot="h3">
                <parts-arrow category="給湯">1</parts-arrow>
                <span>給湯設備・浴室等の有無を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="給湯設備・浴室等の有無"
                class="flex_column"
                name="hw_setti"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name, value) in master.hw_setti"
                    v-model="hw_setti"
                    :value="value"
                    unit=""
                    :key="'hw_setti' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
        </app-section>
        
        <div v-if="hw_setti == '1' || hw_setti == '2'">
            <app-section v-if="hw_setti == '1' || hw_setti == '2'">
                <h3 slot="h3">
                    <parts-arrow category="給湯">2</parts-arrow>
                    <span>
                        <parts-arrow class="line">1</parts-arrow>で「給湯設備がある」を選択した場合、熱源機の種類を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="熱源機の種類"
                    class="flex_column"
                    name="hw_shurui"
                    @click="guideTransition"
                >
                    <div
                        v-for="(valuesArray, index) in [['1','2','3','4','5','6','7'], ['11','12','13','14','15','16','17', '18'], ['21','22','23']]"
                        class="boxinbox"
                        :key="'hw_shurui_s_box' + index"
                    >
                        <span v-if="valuesArray.includes('1')">
                            給湯専用型
                        </span>
                        <span v-else-if="valuesArray.includes('11')">給湯・温水暖房一体型</span>
                        <div>
                            <div
                                v-for="value in valuesArray"
                                :key="'hw_shurui_s' + value"
                            >
                                <app-radio
                                    v-model="hw_shurui_s"
                                    :value="value"
                                    unit=""
                                >
                                    {{master.hw_shurui_s[value]}}
                                </app-radio>
                                <hr v-if="['2','4','6','12','14','15'].includes(value)">
                            </div>
                        </div>
                    </div>
                    <information-box title="太陽熱利用設備と電気ヒートポンプ給湯機を併用する場合">
                        <a href="https://house.lowenergy.jp/dictionary/solar" target="guide" class="target_blank">こちら</a>を参考に入力します。
                    </information-box>
                    <information-box title="コージェネレーションの場合">
                        コージェネタブで評価方法を入力します。
                    </information-box>
                </app-box>
            </app-section>
            
            <!-- 給湯専用型:ガス従来型 -->
            <app-section v-if="hw_shurui_s == '1'">
                <h3 slot="h3">
                    <parts-arrow category="給湯">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">2</parts-arrow>で「給湯専用型：ガス従来型給湯機」を選択した場合、熱源機の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="効率の入力"
                    class="flex_column"
                    name="hw_senyo_sr1_taisaku"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.hw_senyo_sr1_taisaku"
                        v-model="hw_senyo_sr1_taisaku"
                        :value="value"
                        unit=""
                        :key="'hw_senyo_sr1_taisaku' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    v-if="hw_senyo_sr1_taisaku == '2'"
                    label="エネルギー消費効率"
                    class="flex_column"
                >
                    <app-text 
                        v-model="hw_senyo_sr1_e"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    v-if="hw_senyo_sr1_taisaku == '3'"
                    label="モード熱効率"
                    class="flex_column"
                >
                    <app-text
                        v-model="hw_senyo_sr1_emode"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
            </app-section>
            
            <!-- 給湯専用型:ガス潜熱回収型  -->
            <app-section v-if="hw_shurui_s == '2'">
                <h3 slot="h3">
                    <parts-arrow category="給湯">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">2</parts-arrow>で「給湯専用型：ガス潜熱回収型給湯機」を選択した場合、熱源機の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="効率の入力"
                    class="flex_column"
                    name="hw_senyo_sr2_taisaku"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.hw_senyo_sr2_taisaku"
                        v-model="hw_senyo_sr2_taisaku"
                        :value="value"
                        unit=""
                        :key="'hw_senyo_sr2_taisaku' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                    <app-box
                        v-if="hw_senyo_sr2_taisaku  == '2'"
                        label="エネルギー消費効率"
                        info_id=""
                        class="flex_row"
                        :available="true"
                    >
                        <app-text 
                            v-model="hw_senyo_sr2_e" 
                            label=""
                            unit="%"
                            subscript="(小数点以下1桁)"
                            :step="0.1"
                            class="number" 
                        />
                    </app-box>
                    <app-box
                        v-if="hw_senyo_sr2_taisaku  == '3'"
                        label="モード熱効率"
                        info_id=""
                        class="flex_row"
                        :available="true"
                    >
                        <app-text
                            v-model="hw_senyo_sr2_emode"
                            label=""
                            unit="%"
                            subscript="(小数点以下1桁)"
                            :step="0.1"
                            class="number"
                        />
                    </app-box>
            </app-section>
            
            <!-- 給湯専用型:石油従来型 -->
            <app-section v-if="hw_shurui_s == '3'">
                <h3 slot="h3">
                    <parts-arrow category="給湯">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">2</parts-arrow>で「給湯専用型：石油従来型給湯機」を選択した場合、熱源機の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="効率の入力"
                    class="flex_column"
                    name="hw_senyo_sr3_taisaku"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.hw_senyo_sr3_taisaku"
                        v-model="hw_senyo_sr3_taisaku"
                        :value="value"
                        unit=""
                        :key="'hw_senyo_sr3_taisaku' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    v-if="hw_senyo_sr3_taisaku == '2'"
                    label="熱効率"
                    class="flex_row"
                >
                    <app-text
                        v-model="hw_senyo_sr3_e"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    v-if="hw_senyo_sr3_taisaku == '3'"
                    label="モード熱効率"
                    class="flex_row"
                >
                    <!-- 注：emodeでないと計算できないため一時的に書き換えてます（※要確認） -->
                    <app-text
                        v-model="hw_senyo_sr3_emode"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
            </app-section>
            

            <!-- 給湯専用型:石油潜熱回収型 -->
            <app-section v-if="hw_shurui_s == '4'">
                <h3 slot="h3">
                    <parts-arrow category="給湯">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">2</parts-arrow>で「給湯専用型：石油潜熱回収型給湯機」を選択した場合、熱源機の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="効率の入力"
                    class="flex_column"
                    name="hw_senyo_sr4_taisaku"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.hw_senyo_sr4_taisaku"
                        v-model="hw_senyo_sr4_taisaku"
                        :value="value"
                        unit=""
                        :key="'hw_senyo_sr4_taisaku' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    :available="true"
                    v-if="hw_senyo_sr4_taisaku == '2'"
                    label="熱効率"
                    class="flex_row"
                >
                    <app-text
                        v-model="hw_senyo_sr4_e"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    :available="true"
                    v-if="hw_senyo_sr4_taisaku == '3'"
                    label="モード熱効率"
                    class="flex_row"
                >
                    <app-text
                        v-model="hw_senyo_sr4_emode"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
            </app-section>
            

            <!-- 給湯専用型:電気ヒートポンプ給湯機（CO2冷媒）（太陽熱利用設備を使用しないもの） -->
            <app-section v-if="hw_shurui_s == '6'">
                <h3 slot="h3">
                    <parts-arrow category="給湯">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">2</parts-arrow>で「給湯専用型:電気ヒートポンプ給湯機（CO2冷媒）（太陽熱利用設備を使用しないもの）」を選択した場合、熱源機の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="電気ヒートポンプ給湯機の指定"
                    class="flex_column"
                    name="hw_senyo_sr6_spec_method"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name, value) in master.hw_senyo_sr6_spec_method"
                        v-model="hw_senyo_sr6_spec_method"
                        :value="value"
                        unit=""
                        :key="'hw_senyo_sr6_spec_method' + value"
                        :class="{el_radio__pale : value == '3'}"
                    >
                        {{name}}
                    </app-radio>
                    <information-box
                        title="品番を指定しない場合"
                    >
                        品番を指定せずに計算した結果を公的な届出や補助金の申請に利用する場合は、「品番を指定しない（規定値を用いる）」または「品番を指定しない（JIS効率を入力する）」を選択します。
                    </information-box>
                </app-box>
                <!-- 給湯機の仕様を入力する場合 -->
                <div v-if="hw_senyo_sr6_spec_method == '3'">
                    <!-- 試験時の消費電力 -->
                    <app-box
                        :available="true"
                        label="試験時の消費電力" 
                        class="flex_column  param"
                    >
                        <app-text
                            label="中間期標準"
                            unit="kW"
                            v-model="hw_senyo_sr6_P_HP_imd_std"
                            :step="0.001"
                            class="number"
                            subscript="(小数点以下3桁)"
                        />
                        <app-text
                            label="夏期標準"
                            unit="kW"
                            v-model="hw_senyo_sr6_P_HP_sum_std"
                            :step="0.001"
                            class="number"
                            subscript="(小数点以下3桁)"
                        />
                        <app-text
                            label="冬期標準"
                            unit="kW"
                            v-model="hw_senyo_sr6_P_HP_win_std"
                            :step="0.001"
                            class="number"
                            subscript="(小数点以下3桁)"
                        />
                    </app-box>
                    <!-- 試験時の加熱能力 -->
                    <app-box
                        :available="true"
                        label="試験時の加熱能力" 
                        class="flex_column  param"
                    >
                        <app-text
                            label="中間期標準"
                            unit="kW"
                            v-model="hw_senyo_sr6_q_HP_imd_std"
                            :step="0.01"
                            class="number"
                            subscript="(小数点以下2桁)"
                        />
                        <app-text
                            label="夏期標準"
                            unit="kW"
                            v-model="hw_senyo_sr6_q_HP_sum_std"
                            :step="0.01"
                            class="number"
                            subscript="(小数点以下2桁)"
                        />
                        <app-text
                            label="冬期標準"
                            unit="kW"
                            v-model="hw_senyo_sr6_q_HP_win_std"
                            :step="0.01"
                            class="number"
                            subscript="(小数点以下2桁)"
                        />
                    </app-box>
                    <!-- 試験時の着霜期高温エネルギー消費効率 -->
                    <app-box
                        :available="true"
                        label="試験時の着霜期高温エネルギー消費効率" 
                        class="flex_column"
                    >
                        <app-text
                            unit=""
                            v-model="hw_senyo_sr6_e_HP_def_high"
                            :step="0.01"
                            class="number"
                            subscript="(小数点以下2桁)"
                        />
                    </app-box>
                    <!-- 試験時の着霜期高温ヒートポンプ運転時エネルギー消費効率 -->
                    <app-box
                        :available="true"
                        label="試験時の着霜期高温ヒートポンプ運転時エネルギー消費効率" 
                        class="flex_column"
                    >
                        <app-text
                            unit=""
                            v-model="hw_senyo_sr6_e_HP_frst_high"
                            :step="0.01"
                            class="number"
                            subscript="(小数点以下2桁)"
                        />
                    </app-box>
                    <!-- 試験時の沸上げ温度 -->
                    <app-box
                        :available="true"
                        label="試験時の沸上げ温度" 
                        class="flex_column  param"
                    >
                        <app-text
                            label="着霜期高温"
                            unit="℃"
                            v-model="hw_senyo_sr6_theta_bw_frst_high"
                            :step="0.1"
                            class="number"
                            subscript="(小数点以下1桁)"
                        />
                        <app-text
                            label="中間期標準"
                            unit="℃"
                            v-model="hw_senyo_sr6_theta_bw_imd_std"
                            :step="0.1"
                            class="number"
                            subscript="(小数点以下1桁)"
                        />
                        <app-text
                            label="夏期標準"
                            unit="℃"
                            v-model="hw_senyo_sr6_theta_bw_sum_std"
                            :step="0.1"
                            class="number"
                            subscript="(小数点以下1桁)"
                        />
                        <app-text
                            label="冬期標準"
                            unit="℃"
                            v-model="hw_senyo_sr6_theta_bw_win_std"
                            :step="0.1"
                            class="number"
                            subscript="(小数点以下1桁)"
                        />
                    </app-box>
                    <!-- ヒートポンプ消費電力を求める回帰式 -->
                    <app-box
                        :available="true"
                        label="ヒートポンプ消費電力を求める回帰式" 
                        class="flex_column  param"
                    >
                        <app-text
                            label="係数Ap"
                            unit="kW/℃"
                            v-model="hw_senyo_sr6_A_p"
                            :step="0.0001"
                            class="number"
                            subscript="(小数点以下4桁)"
                        />
                        <app-text
                            label="係数Bp"
                            unit="kW"
                            v-model="hw_senyo_sr6_B_p"
                            :step="0.0001"
                            class="number"
                            subscript="(小数点以下4桁)"
                        />
                    </app-box>
                    <!-- 補機消費電力 -->
                    <app-box
                        :available="true"
                        label="補機消費電力" 
                        class="flex_column  param"
                    >
                        <app-text
                            label="ヒートポンプ運転時"
                            unit="W"
                            v-model="hw_senyo_sr6_P_aux_HP_on"
                            :step="1"
                            class="number"
                            subscript="(整数)"
                        />
                        <app-text
                            label="ヒートポンプ停止時"
                            unit="W"
                            v-model="hw_senyo_sr6_P_aux_HP_off"
                            :step="1"
                            class="number"
                            subscript="(整数)"
                        />
                    </app-box>
                    <!-- 給湯保温モード貯湯損失熱量 -->
                    <app-box
                        :available="true"
                        label="給湯保温モード貯湯損失熱量" 
                        class="flex_column"
                    >
                        <app-text
                            label=""
                            unit="MJ/d"
                            v-model="hw_senyo_sr6_Q_loss"
                            :step="0.1"
                            class="number"
                            subscript="(小数点以下1桁)"
                        />
                    </app-box>
                    <!-- 貯湯タンク総括熱抵抗 -->
                    <app-box
                        :available="true"
                        label="貯湯タンク総括熱抵抗" 
                        class="flex_column"
                    >
                        <app-text
                            label=""
                            unit="K/W"
                            v-model="hw_senyo_sr6_R_tnk"
                            :step="0.01"
                            class="number"
                            subscript="(小数点以下2桁)"
                        />
                    </app-box>
                    <!-- 試験時の冬期M1スタンダードモード沸上げ温度 -->
                    <app-box
                        :available="true"
                        label="試験時の冬期M1スタンダードモード沸上げ温度" 
                        class="flex_column  param"
                    >
                        <app-text
                            label="ファーストモード"
                            unit="℃"
                            v-model="hw_senyo_sr6_theta_hat_bw_win_cm_first"
                            :step="1"
                            class="number"
                            subscript="(整数)"
                        />
                        <app-text
                            label="セカンドモード"
                            unit="℃"
                            v-model="hw_senyo_sr6_theta_hat_bw_win_cm_second"
                            :step="1"
                            class="number"
                            subscript="(整数)"
                        />
                    </app-box>
                </div>
                <!-- 給湯機の効率から仕様を決定する場合 -->
                <app-box
                    :available="true"
                    v-if="hw_senyo_sr6_spec_method == '2'"
                    label="JIS効率"
                    class="flex_row"
                    name="hw_senyo_sr6_e"
                    @click="guideTransition"
                >
                    <app-text
                        v-model="hw_senyo_sr6_e"
                        label=""
                        unit=""
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <!-- 品番入力 -->
                <app-box
                    :available="true"
                    v-if="hw_senyo_sr6_spec_method == '4'"
                    label="品番"
                    class="flex_column"
                    name="hw_senyo_sr6_shinaban"
                    @click="guideTransition"
                >
                    <search-button 
                        v-model="electricHeatPumpFilter"
                        id="searchText2"
                        label="メーカ名、品番等"
                        placeholder=""
                        button-name="検索"
                        class="str15em align_left"
                        @click="searchElectricHeatPumpPackage"
                    />
                    <selected-hot-water-table 
                        v-if="electricHeatPumpSelected.value != undefined" 
                        :selected-data="electricHeatPumpSelected"
                    />
                    <information-box
                        title="給湯専用型:電気ヒートポンプ給湯機（CO2冷媒）を指定する場合"
                        class="hundred_percent"
                    >
                        <p>メーカ名・品番等については、
                        <a
                            href="https://shoenekikiportal.hyoukakyoukai.or.jp/#/electric_heat_pumps"
                            target="_blank"
                            class="target_blank"
                        >
                            こちら
                        </a>
                        の機器の登録情報を確認します。</p>
                    </information-box>
                </app-box>

            </app-section>
            
            <!-- 給湯専用型:電気ヒートポンプ・ガス瞬間式併用型給湯機 -->
            <app-section v-if="hw_shurui_s == '7'">
                <h3 slot="h3">
                    <parts-arrow category="給湯">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">2</parts-arrow>で「給湯専用型:電気ヒートポンプ・ガス瞬間式併用型給湯機」を選択した場合、熱源機の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    label="電気ヒートポンプ・ガス瞬間式併用型給湯機の指定"
                    info_id=""
                    class="flex_column"
                    :available="true"
                    name="hw_senyo_sr7_package_input"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="value in ['2','3','1']"
                        v-model="hw_senyo_sr7_package_input"
                        :value="value"
                        unit=""
                        :key="'hw_senyo_sr7_package_input' + value"
                    >
                        {{master.hw_senyo_sr7_package_input[value]}}
                    </app-radio>
                </app-box>
                <div v-if="hw_senyo_sr7_package_input == '1'">
                    <app-box
                        label="品番"
                        info_id=""
                        class="flex_column"
                        :available="true"
                        name="hw_senyo_sr7_shinaban"
                        @click="guideTransition"
                    >
                        <search-button 
                            v-model="hybridwaterheater_senyo_filter"
                            id="searchText"
                            label="メーカ名、品番等"
                            placeholder=""
                            button-name="検索"
                            class="str15em align_left"
                            @click="searchHybridWaterHeaterSenyo"
                        />
                        <selected-hot-water-table 
                            v-if="hwSenyoSelected.value != undefined"
                            :selected-data="hwSenyoSelected"
                        />
                        <information-box
                            title="電気ヒートポンプ・ガス瞬間式併用型給湯機を指定する場合"
                            class="hundred_percent"
                        >
                            <p>メーカ名・品番等については、
                            <a
                                href="https://shoenekikiportal.hyoukakyoukai.or.jp/#/hybrid_water_heaters"
                                target="_blank"
                                class="target_blank"
                            >
                                こちら
                            </a>
                            の機器の登録情報を確認します。</p>
                        </information-box>
                    </app-box>
                </div>
                <div v-if="hw_senyo_sr7_package_input == '2'">
                    <app-box
                        label="冷媒の種類"
                        info_id=""
                        class="flex_row"
                        :available="true"
                        name="hw_senyo_sr7_coolant_type"
                        @click="guideTransition"
                    >
                        <app-radio
                            v-for="(name,value) in master.hw_senyo_sr7_coolant_type"
                            v-model="hw_senyo_sr7_coolant_type"
                            :value="value"
                            unit=""
                            :key="'hw_senyo_sr7_coolant_type' + value"
                        >
                            {{name}}
                        </app-radio>
                    </app-box>
                    <app-box
                        v-if="hw_senyo_sr7_coolant_type == '1'"
                        label="タンクユニット容量"
                        info_id=""
                        class="flex_row"
                        :available="true"
                        name="hw_senyo_sr7_tank"
                        @click="guideTransition"
                    >
                        <app-radio
                            v-for="(name,value) in master.hw_senyo_sr7_tank"
                            v-model="hw_senyo_sr7_tank"
                            :value="value"
                            unit=""
                            :key="'hw_senyo_sr7_tank' + value"
                        >
                            {{name}}
                        </app-radio>
                    </app-box>
                </div>
                
                <!-- 直接指定する場合 -->
                <div v-if="hw_shurui_s == '7' && hw_senyo_sr7_package_input == '3'">
                    <!-- 電気ヒートポンプの加熱量を求める式の係数 -->
                    <app-box
                        :available="true"
                        label="電気ヒートポンプの加熱量を求める式の係数" 
                        class="flex_column  param"
                    >
                        <app-text
                            label="1"
                            unit="-"
                            v-model="hw_hybrid_a_HP"
                            :step="0.0001"
                            class="number"
                            subscript="(小数点以下4桁)"
                        />
                        <app-text
                            label="2"
                            unit="-"
                            v-model="hw_hybrid_b_HP"
                            :step="0.0001"
                            class="number"
                            subscript="(小数点以下4桁)"
                        />
                    </app-box>
                    <!-- タンクユニットの消費電力量を求める式の係数 -->
                    <app-box
                        :available="true"
                        label="タンクユニットの消費電力量を求める式の係数" 
                        class="flex_column  param"
                    >
                        <app-text
                            label="1"
                            unit="-"
                            v-model="hw_hybrid_a_TU"
                            :step="0.0001"
                            class="number"
                            subscript="(小数点以下4桁)"
                        />
                        <app-text
                            label="2"
                            unit="-"
                            v-model="hw_hybrid_b_TU"
                            :step="0.0001"
                            class="number"
                            subscript="(小数点以下4桁)"
                        />
                    </app-box>
                    <!-- 電気ヒートポンプの基準熱効率 -->
                    <app-box
                        :available="true"
                        label="電気ヒートポンプの基準熱効率" 
                        class="flex_column  param"
                    >
                        <app-text
                            label="外気温度-7℃"
                            unit="-"
                            v-model="hw_hybrid_e_HPstd_m7"
                            :step="0.0001"
                            class="number"
                            subscript="(小数点以下4桁)"
                        />
                        <app-text
                            label="外気温度2℃"
                            unit="-"
                            v-model="hw_hybrid_e_HPstd_2"
                            :step="0.0001"
                            class="number"
                            subscript="(小数点以下4桁)"
                        />
                        <app-text
                            label="外気温度7℃"
                            unit="-"
                            v-model="hw_hybrid_e_HPstd_7"
                            :step="0.0001"
                            class="number"
                            subscript="(小数点以下4桁)"
                        />
                        <app-text
                            label="外気温度25℃"
                            unit="-"
                            v-model="hw_hybrid_e_HPstd_25"
                            :step="0.0001"
                            class="number"
                            subscript="(小数点以下4桁)"
                        />
                    </app-box>
                    <!-- 電気ヒートポンプの最大加熱量 -->
                    <app-box
                        :available="true"
                        label="電気ヒートポンプの最大加熱量"
                        class="flex_column"
                    >
                        <app-text
                            v-model="hw_hybrid_Q_HP_max"
                            label=""
                            unit="MJ/日"
                            subscript="(小数点以下4桁)"
                            :step="0.0001"
                            class="number"
                        />
                    </app-box>
                    <!-- タンクユニットの年平均熱損失率 -->
                    <app-box
                        :available="true"
                        label="タンクユニットの年平均熱損失率"
                        class="flex_column"
                    >
                        <app-text
                            v-model="hw_hybrid_eta_loss_TU"
                            label=""
                            unit="-"
                            subscript="(小数点以下4桁)"
                            :step="0.0001"
                            class="number"
                        />
                    </app-box>
                    <!-- 電気ヒートポンプの運転下限外気温度 -->
                    <app-box
                        :available="true"
                        label="電気ヒートポンプの運転下限外気温度"
                        class="flex_column"
                    >
                        <app-text
                            v-model="hw_hybrid_theta_ex_min_HP"
                            label=""
                            unit="℃"
                            subscript="(小数点以下4桁)"
                            :step="0.0001"
                            class="number"
                        />
                    </app-box>
                    <!-- バックアップボイラーの熱効率（給湯モード熱効率） -->
                    <app-box
                        :available="true"
                        label="バックアップボイラーの熱効率（給湯モード熱効率）" 
                        class="flex_column"
                    >
                        <app-text
                            label=""
                            unit="-"
                            v-model="hw_hybrid_e_BB_jis"
                            :step="0.001"
                            class="number"
                            subscript="(小数点以下3桁)"
                        />
                    </app-box>
                    <!-- ヒートポンプ昼間沸上率 -->
                    <app-box
                        :available="true"
                        label="ヒートポンプ昼間沸上率"
                        class="flex_column"
                    >
                        <app-text
                            v-model="hw_hybrid_R_day"
                            label=""
                            unit="-"
                            subscript="(小数点以下4桁)"
                            :step="0.0001"
                            class="number"
                        />
                    </app-box>
                </div>
            </app-section>
            

            <!-- 給湯・温水暖房一体型:ガス従来型給湯温水暖房機 -->
            <app-section v-if="hw_shurui_s == '11'">
                <h3 slot="h3">
                    <parts-arrow category="給湯">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">2</parts-arrow>で「給湯・温水暖房一体型:ガス従来型給湯温水暖房機」を選択した場合、熱源機の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="効率の入力"
                    class="flex_column"
                    name="hw_ittai_sr11_taisaku" 
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name,value) in master.hw_ittai_sr11_taisaku"
                        v-model="hw_ittai_sr11_taisaku"
                        :value="value"
                        unit=""
                        :key="'hw_ittai_sr11_taisaku' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    v-if="hw_ittai_sr11_taisaku == '2' || hw_ittai_sr11_taisaku == '3'"
                    :available="true"
                    label="暖房部 熱効率"
                    class="flex_row"
                >
                    <app-text
                        v-model="hw_ittai_sr11_heater_e"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    v-if="hw_ittai_sr11_taisaku == '2'"
                    :available="true"
                    label="給湯部 エネルギー消費効率"
                    class="flex_row"
                >
                    <app-text
                        v-model="hw_ittai_sr11_hotwater_e"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    v-if="hw_ittai_sr11_taisaku == '3'"
                    :available="true"
                    label="給湯部 モード熱効率"
                    class="flex_row"
                >
                    <app-text
                        v-model="hw_ittai_sr11_hotwater_emode"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
            </app-section>
            

            <!-- 給湯・温水暖房一体型:ガス潜熱回収型給湯温水暖房機 -->
            <app-section v-if="hw_shurui_s == '12'">
                <h3 slot="h3">
                    <parts-arrow category="給湯">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">2</parts-arrow>で「給湯・温水暖房一体型:ガス潜熱回収型給湯温水暖房機」を選択した場合、熱源機の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="効率の入力"
                    class="flex_column"
                    name="hw_ittai_sr12_taisaku"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name,value) in master.hw_ittai_sr12_taisaku"
                        v-model="hw_ittai_sr12_taisaku"
                        :value="value"
                        unit=""
                        :key="'hw_ittai_sr12_taisaku' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    v-if="hw_ittai_sr12_taisaku == '2' || hw_ittai_sr12_taisaku == '3'"
                    :available="true"
                    label="暖房部 熱効率"
                    class="flex_row"
                >
                    <app-text
                        v-model="hw_ittai_sr12_heater_e"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    v-if="hw_ittai_sr12_taisaku == '2'"
                    :available="true"
                    label="給湯部 エネルギー消費効率"
                    class="flex_row"
                >
                    <app-text
                        v-model="hw_ittai_sr12_hotwater_e"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    v-if="hw_ittai_sr12_taisaku == '3'"
                    :available="true"
                    label="給湯部 モード熱効率"
                    class="flex_row"
                >
                    <app-text
                        v-model="hw_ittai_sr12_hotwater_emode"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
            </app-section>
            
            
            <!-- 給湯・温水暖房一体型:石油従来型給湯温水暖房機 -->
            <app-section v-if="hw_shurui_s == '13'">
                <h3 slot="h3">
                    <parts-arrow category="給湯">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">2</parts-arrow>で「給湯・温水暖房一体型:石油従来型給湯温水暖房機」を選択した場合、熱源機の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="効率の入力"
                    class="flex_column"
                    name="hw_ittai_sr13_taisaku"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name,value) in master.hw_ittai_sr13_taisaku"
                        v-model="hw_ittai_sr13_taisaku"
                        :value="value"
                        unit=""
                        :key="'hw_ittai_sr13_taisaku' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                <app-box
                    v-if="hw_ittai_sr13_taisaku == '2' || hw_ittai_sr13_taisaku == '3'"
                    :available="true"
                    label="暖房部 熱効率"
                    class="flex_row"
                >
                    <app-text 
                        v-model="hw_ittai_sr13_heater_e"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    v-if="hw_ittai_sr13_taisaku == '2'"
                    :available="true"
                    label="給湯部 熱効率"
                    class="flex_row"
                >
                    <app-text
                        v-model="hw_ittai_sr13_hotwater_e"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    v-if="hw_ittai_sr13_taisaku == '3'"
                    :available="true"
                    label="給湯部 モード熱効率"
                    class="flex_row"
                >
                    <app-text
                        v-model="hw_ittai_sr13_hotwater_emode"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
            </app-section>
            

            <!-- 給湯・温水暖房一体型：石油潜熱回収型給湯温水暖房機 -->
            <app-section v-if="hw_shurui_s == '14'">
                <h3 slot="h3">
                    <parts-arrow category="給湯">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">2</parts-arrow>で「給湯・温水暖房一体型：石油潜熱回収型給湯温水暖房機」を選択した場合、熱源機の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="効率の入力"
                    class="flex_column"
                    name="hw_ittai_sr14_taisaku"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="(name,value) in master.hw_ittai_sr14_taisaku"
                        v-model="hw_ittai_sr14_taisaku"
                        :value="value"
                        unit=""
                        :key="'hw_ittai_sr14_taisaku' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-box>
                
                <app-box
                    v-if="hw_ittai_sr14_taisaku == '2'"
                    :available="true"
                    label="給湯部 熱効率"
                    class="flex_row"
                >
                    <app-text 
                        v-model="hw_ittai_sr14_hotwater_e"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
                <app-box
                    v-if="hw_ittai_sr14_taisaku == '3'"
                    :available="true"
                    label="給湯部 モード熱効率"
                    class="flex_row"
                >
                    <app-text
                        v-model="hw_ittai_sr14_hotwater_emode"
                        label=""
                        unit="%"
                        subscript="(小数点以下1桁)"
                        :step="0.1"
                        class="number"
                    />
                </app-box>
            </app-section>
            

            <!-- 給湯・温水暖房一体型：電気ヒートポンプ・ガス併用型給湯温水暖房機 
            「暖房部：電気ヒートポンプ・ガス、給湯部：ガス」を選択した場合。 -->
            <app-section v-if="hw_shurui_s == '16'">
                <h3 slot="h3">
                    <parts-arrow category="給湯">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">2</parts-arrow>で「電気ヒートポンプ・ガス瞬間式併用型給湯温水暖房機<small>（暖房部：電気ヒートポンプ・ガス | 給湯部：ガス）</small>」を選択した場合、熱源機の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="タンクユニットの設置場所"
                    class="flex_column"
                    name="hw_ittai_sr16_tank"
                    @click="helpView"
                >
                    <app-radio
                        v-for="value in ['2','1']"
                        v-model="hw_ittai_sr16_tank"
                        :value="value"
                        unit=""
                        :key="'hw_ittai_sr16_tank' + value"
                    >
                        {{master.hw_ittai_sr16_tank[value]}}
                    </app-radio>
                </app-box>
            </app-section>
            

            <!-- 給湯・温水暖房一体型：電気ヒートポンプ・ガス併用型給湯温水暖房機 
            「暖房部：電気ヒートポンプ・ガス、給湯部：電気ヒートポンプ・ガス」を選択した場合。 -->
            <app-section v-if="hw_shurui_s == '17'">
                <h3 slot="h3">
                    <parts-arrow category="給湯">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">2</parts-arrow>で「電気ヒートポンプ・ガス瞬間式併用型給湯温水暖房機<small>（暖房部：電気ヒートポンプ・ガス | 給湯部：電気ヒートポンプ・ガス）</small>」を選択した場合、熱源機の評価方法を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="電気ヒートポンプ・ガス瞬間式併用型給湯温水暖房機の区分"
                    class="flex_column"
                    name="hw_ittai_sr17_kubun"
                    @click="guideTransition"
                >
                    <app-radio
                        v-for="value in 2"
                        v-model="hw_ittai_sr17_kubun"
                        :value="value.toString()"
                        unit=""
                        :key="'hw_ittai_sr17_kubun' + value"
                    >
                        区分{{value}}
                    </app-radio>
                </app-box>
            </app-section>
            

            <!-- 給湯・温水暖房一体型：電気ヒートポンプ・ガス併用型給湯温水暖房機 
            「暖房部：ガス、給湯部：電気ヒートポンプ・ガス」を選択した場合。 -->
            <app-section v-if="hw_shurui_s == '18'">
                <h3 slot="h3">
                    <parts-arrow category="給湯">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">2</parts-arrow>で「電気ヒートポンプ・ガス瞬間式併用型給湯温水暖房機<small>（暖房部：ガス | 給湯部：電気ヒートポンプ・ガス）</small>」を選択した場合、熱源機の評価方法を入力して下さい。
                    </span>
                </h3>
                <div>
                    <app-box
                        :available="true"
                        label="電気ヒートポンプ・ガス瞬間式併用型給湯機の指定"
                        class="flex_column"
                        name="hw_ittai_sr18_package_input"
                        @click="guideTransition"
                    >
                        <app-radio
                            v-for="value in ['2','3','1']"
                            v-model="hw_ittai_sr18_package_input"
                            :value="value"
                            unit=""
                            :key="'hw_ittai_sr18_package_input' + value"
                            :class="{el_radio__pale : value == '3'}"
                        >
                            {{master.hw_ittai_sr18_package_input[value]}}
                        </app-radio>
                        <information-box
                            title="品番を指定しない場合"
                        >
                            品番を指定せずに計算した結果を公的な届出や補助金の申請に利用する場合は、「品番を指定しない（仕様を選択する）」を選択します。
                        </information-box>
                    </app-box>
                    <app-box
                        :available="true"
                        v-if="hw_ittai_sr18_package_input == '1'"
                        label="品番"
                        class="flex_column"
                        name="hw_ittai_sr18_shinaban"
                        @click="guideTransition"
                    >
                        <search-button 
                            v-model="hybridwaterheater_ittai_filter"
                            id="searchText2"
                            label="メーカ名、品番等"
                            placeholder=""
                            button-name="検索"
                            class="str15em align_left"
                            @click="searchHybridWaterHeaterIttai"
                        />
                        <selected-hot-water-table 
                            v-if="hwIttaiSelected.value != undefined" 
                            :selected-data="hwIttaiSelected"
                        />
                        <information-box
                            title="電気ヒートポンプ・ガス瞬間式併用型給湯機を指定する場合"
                            class="hundred_percent"
                        >
                            <p>メーカ名・品番等については、
                            <a
                                href="https://shoenekikiportal.hyoukakyoukai.or.jp/#/hybrid_water_heaters"
                                target="_blank"
                                class="target_blank"
                            >
                                こちら
                            </a>
                            の機器の登録情報を確認します。</p>
                        </information-box>
                    </app-box>
                    <app-box
                        :available="true"
                        v-if="hw_ittai_sr18_package_input == '2'"
                        label="冷媒の種類"
                        class="flex_row"
                        name="hw_ittai_sr18_coolant_type"
                        @click="guideTransition"
                    >
                        <app-radio
                            v-for="(name,value) in master.hw_ittai_sr18_coolant_type"
                            v-model="hw_ittai_sr18_coolant_type"
                            :value="value"
                            unit=""
                            :key="'hw_ittai_sr18_coolant_type' + value"
                        >
                            {{name}}
                        </app-radio>
                    </app-box>
                    <app-box
                        :available="true"
                        v-if="hw_ittai_sr18_package_input == '2' && hw_ittai_sr18_coolant_type == '1'"
                        label="タンクユニット容量"
                        class="flex_row"
                        name="hw_ittai_sr18_tank"
                        @click="guideTransition"
                    >
                        <app-radio
                            v-for="(name,value) in master.hw_ittai_sr18_tank"
                            v-model="hw_ittai_sr18_tank"
                            :value="value"
                            unit=""
                            :key="'hw_ittai_sr18_tank' + value"
                        >
                            {{name}}
                        </app-radio>
                    </app-box>
                    
                    <!-- 直接指定する場合 -->
                    <div v-if="hw_shurui_s == '18' && hw_ittai_sr18_package_input == '3'">
                        <!-- 電気ヒートポンプの加熱量を求める式の係数 -->
                        <app-box
                            :available="true"
                            label="電気ヒートポンプの加熱量を求める式の係数" 
                            class="flex_column  param"
                        >
                            <app-text
                                label="1"
                                unit="-"
                                v-model="hw_hybrid_a_HP"
                                :step="0.0001"
                                class="number"
                                subscript="(小数点以下4桁)"
                            />
                            <app-text
                                label="2"
                                unit="-"
                                v-model="hw_hybrid_b_HP"
                                :step="0.0001"
                                class="number"
                                subscript="(小数点以下4桁)"
                            />
                        </app-box>
                        <!-- タンクユニットの消費電力量を求める式の係数 -->
                        <app-box
                            :available="true"
                            label="タンクユニットの消費電力量を求める式の係数" 
                            class="flex_column  param"
                        >
                            <app-text
                                label="1"
                                unit="-"
                                v-model="hw_hybrid_a_TU"
                                :step="0.0001"
                                class="number"
                                subscript="(小数点以下4桁)"
                            />
                            <app-text
                                label="2"
                                unit="-"
                                v-model="hw_hybrid_b_TU"
                                :step="0.0001"
                                class="number"
                                subscript="(小数点以下4桁)"
                            />
                        </app-box>
                        <!-- 電気ヒートポンプの基準熱効率 -->
                        <app-box
                            :available="true"
                            label="電気ヒートポンプの基準熱効率" 
                            class="flex_column  param"
                        >
                            <app-text
                                label="外気温度-7℃"
                                unit="-"
                                v-model="hw_hybrid_e_HPstd_m7"
                                :step="0.0001"
                                class="number"
                                subscript="(小数点以下4桁)"
                            />
                            <app-text
                                label="外気温度2℃"
                                unit="-"
                                v-model="hw_hybrid_e_HPstd_2"
                                :step="0.0001"
                                class="number"
                                subscript="(小数点以下4桁)"
                            />
                            <app-text
                                label="外気温度7℃"
                                unit="-"
                                v-model="hw_hybrid_e_HPstd_7"
                                :step="0.0001"
                                class="number"
                                subscript="(小数点以下4桁)"
                            />
                            <app-text
                                label="外気温度25℃"
                                unit="-"
                                v-model="hw_hybrid_e_HPstd_25"
                                :step="0.0001"
                                class="number"
                                subscript="(小数点以下4桁)"
                            />
                        </app-box>
                        <!-- 電気ヒートポンプの最大加熱量 -->
                        <app-box
                            :available="true"
                            label="電気ヒートポンプの最大加熱量"
                            class="flex_column"
                        >
                            <app-text
                                v-model="hw_hybrid_Q_HP_max"
                                label=""
                                unit="MJ/日"
                                subscript="(小数点以下4桁)"
                                :step="0.0001"
                                class="number"
                            />
                        </app-box>
                        <!-- タンクユニットの年平均熱損失率 -->
                        <app-box
                            :available="true"
                            label="タンクユニットの年平均熱損失率"
                            class="flex_column"
                        >
                            <app-text
                                v-model="hw_hybrid_eta_loss_TU"
                                label=""
                                unit="-"
                                subscript="(小数点以下4桁)"
                                :step="0.0001"
                                class="number"
                            />
                        </app-box>
                        <!-- 電気ヒートポンプの運転下限外気温度 -->
                        <app-box
                            :available="true"
                            label="電気ヒートポンプの運転下限外気温度"
                            class="flex_column"
                        >
                            <app-text
                                v-model="hw_hybrid_theta_ex_min_HP"
                                label=""
                                unit="℃"
                                subscript="(小数点以下4桁)"
                                :step="0.0001"
                                class="number"
                            />
                        </app-box>
                        <!-- バックアップボイラーの熱効率（給湯モード熱効率） -->
                        <app-box
                            :available="true"
                            label="バックアップボイラーの熱効率（給湯モード熱効率）" 
                            class="flex_column"
                        >
                            <app-text
                                label=""
                                unit="-"
                                v-model="hw_hybrid_e_BB_jis"
                                :step="0.001"
                                class="number"
                                subscript="(小数点以下3桁)"
                            />
                        </app-box>
                        <!-- ヒートポンプ昼間沸上率 -->
                        <app-box
                            :available="true"
                            label="ヒートポンプ昼間沸上率"
                            class="flex_column"
                        >
                            <app-text
                                v-model="hw_hybrid_R_day"
                                label=""
                                unit="-"
                                subscript="(小数点以下4桁)"
                                :step="0.0001"
                                class="number"
                            />
                        </app-box>
                    </div>
                </div>
            </app-section>

            <!-- その他の給湯設備機器 -->
            <app-section v-if="hw_shurui_s == '22'">
                <h3 slot="h3">
                    <parts-arrow category="給湯">3</parts-arrow>
                    <span>
                        <parts-arrow class="line">2</parts-arrow>で「その他の給湯設備機器」を選択した場合、その他の給湯設備機器の名称を入力して下さい。
                    </span>
                </h3>
                <app-box
                    :available="true"
                    label="その他の給湯設備機器の名称"
                    class="flex_column"
                >
                    <app-text
                        label=""
                        unit=""
                        v-model="hw_other_name"
                        class=""
                        subscript=""
                    />
                </app-box>
            </app-section>
        </div>

        <app-section
            caption=""
            v-if="isBath"
        >
            <h3 slot="h3">
                <parts-arrow category="給湯">4</parts-arrow>
                <span><parts-arrow class="line">1</parts-arrow>で「給湯設備がある」を選択した場合、ふろ機能の種類を入力して下さい。</span>
            </h3>
            <app-box
                :available="true"
                label="ふろ機能の種類"
                class="flex_column"
                name="hw_src_type"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name,value) in master.hw_src_type"
                    v-model="hw_src_type"
                    :value="value"
                    unit=""
                    :key="'hw_src_type' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
        </app-section>

        <!-- 配管方式 -->
        <app-section v-if="hw_setti == '1' || hw_setti == '2'">
            <h3 slot="h3">
                <parts-arrow category="給湯">5</parts-arrow>
                <span>配管方式の評価方法を入力して下さい。</span>
            </h3>
            <app-box
                label="配管方式"
                info_id=""
                class="flex_column"
                :available="true"
                name="hw_header_type"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name,value) in master.hw_header_type"
                    v-model="hw_header_type"
                    :value="value"
                    unit=""
                    :key="'hw_header_type' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
            <app-box
                label="ヘッダー分岐後の配管径"
                :available="true"
                v-if="hw_header_type == 2"
            >
                <app-radio
                    v-for="value in ['2','1']"
                    v-model="hw_pipesize"
                    :value="value"
                    unit=""
                    :key="'hw_pipesize' + value"
                >
                    {{master.hw_pipesize[value]}}
                </app-radio>
            </app-box>
        </app-section>

        <!-- 水栓 -->
        <app-section v-if="hw_setti !== '3'">
            <h3 slot="h3">
                <parts-arrow category="給湯">6</parts-arrow>
                <span>
                    <parts-arrow class="line">1</parts-arrow>で「給湯設備がある」を選択した場合、水栓の評価方法を入力して下さい。
                </span>
            </h3>
            <app-box
                label="台所水栓"
                info_id=""
                class="flex_column"
                name="hw_suisen"
                @click="guideTransition"
                :available="true"
            >
                <app-radio
                    v-for="(name,value) in master.hw_daidokoro_suisen"
                    v-model="hw_daidokoro_suisen"
                    :value="value"
                    unit=""
                    :key="'hw_daidokoro_suisen' + value"
                >
                    {{name}}
                </app-radio>
                <app-radio-sub-box
                    label="手元止水機能"
                    name="hw_daidokoro_temoto"
                    @click="guideTransition"
                    v-if="hw_daidokoro_suisen == 2"
                >
                    <app-radio
                        v-for="(name,value) in master.hw_daidokoro_temoto"
                        v-model="hw_daidokoro_temoto"
                        :value="value"
                        unit=""
                        :key="'hw_daidokoro_temoto' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-radio-sub-box>
                <app-radio-sub-box
                    label="水優先吐水機能"
                    name="hw_daidokoro_yusen"
                    @click="guideTransition"
                    v-if="hw_daidokoro_suisen == 2"
                >
                    <app-radio
                        v-for="(name,value) in master.hw_daidokoro_yusen"
                        v-model="hw_daidokoro_yusen"
                        :value="value"
                        unit=""
                        :key="'hw_daidokoro_yusen' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-radio-sub-box>
            </app-box>
            <app-box
                v-if="hw_setti == '1'"
                label="浴室シャワー水栓"
                info_id=""
                class="flex_column"
                :available="true"
                name="hw_shower_suisen"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name,value) in master.hw_shower_suisen"
                    v-model="hw_shower_suisen"
                    :value="value"
                    unit=""
                    :key="'hw_shower_suisen' + value"
                >
                    {{name}}
                </app-radio>
                <app-radio-sub-box
                    label="手元止水機能"
                    name="hw_shower_temoto"
                    @click="guideTransition"
                    v-if="hw_shower_suisen == 2"
                >
                    <app-radio
                        v-for="(name,value) in master.hw_shower_temoto"
                        v-model="hw_shower_temoto"
                        :value="value"
                        unit=""
                        :key="'hw_shower_temoto' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-radio-sub-box>
                <app-radio-sub-box
                    label="小流量吐水機能"
                    name="hw_shower_shoryuryo"
                    @click="guideTransition"
                    v-if="hw_shower_suisen == 2"
                >
                    <app-radio
                        v-for="(name,value) in master.hw_shower_shoryuryo"
                        v-model="hw_shower_shoryuryo"
                        :value="value"
                        unit=""
                        :key="'hw_shower_shoryuryo' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-radio-sub-box>
            </app-box>
            <app-box
                label="洗面水栓"
                info_id=""
                class="flex_column"
                :available="true"
                name="hw_senmen_suisen"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name,value) in master.hw_senmen_suisen"
                    v-model="hw_senmen_suisen"
                    :value="value"
                    unit=""
                    :key="'hw_senmen_suisen' + value"
                >
                    {{name}}
                </app-radio>
                <app-radio-sub-box
                    label="水優先吐水機能"
                    name="hw_senmen_yusen"
                    @click="guideTransition"
                    v-if="hw_senmen_suisen == 2"
                >
                    <app-radio
                        v-for="(name,value) in master.hw_senmen_yusen"
                        v-model="hw_senmen_yusen"
                        :value="value"
                        unit=""
                        :key="'hw_senmen_yusen' + value"
                    >
                        {{name}}
                    </app-radio>
                </app-radio-sub-box>
            </app-box>
        </app-section>

        <!-- 浴槽 -->
        <app-section v-if="hw_setti == '1'">
            <h3 slot="h3">
                <parts-arrow category="給湯">7</parts-arrow>
                <span>
                    <parts-arrow class="line">1</parts-arrow>で「給湯設備がある（浴室等がある）」を選択した場合、浴槽の保温措置の評価方法を入力して下さい。
                </span>
            </h3>
            <app-box
                label="浴槽の保温措置"
                info_id=""
                class="flex_column"
                :available="true"
                name="hw_yokuso_hoon"
                @click="guideTransition"
            >
                <app-radio
                    v-for="(name,value) in master.hw_yokuso_hoon"
                    v-model="hw_yokuso_hoon"
                    :value="value"
                    unit=""
                    :key="'hw_yokuso_hoon' + value"
                >
                    {{name}}
                </app-radio>
            </app-box>
        </app-section>
        <!-- 内容ここまで -->
    </div>
</div>
</template>

<script>
/**
 * 詳細版給湯情報入力画面
 * 
 * [算出プロパティ]
 * hybridwaterheaterSenyoFilter ... 給湯専用型の検索フィルタ
 * hybridwaterheaterIttaiFilter ... 給湯・温水暖房一体型用検索フィルタ
 * hwSenyoSelected ... 給湯専用型の選択済み機器
 * hwIttaiSelected ... 給湯・温水暖房一体型の選択済み機器
 * 他は詳細版インタフェイス定義の同名項目に準ずる
 * 
 * [イベント処理]
 * インタフェイス定義済み項目の更新時 ... Storeの該当するキーのデータも更新される
 * 給湯専用型検索時 ... 給湯専用型の検索である情報を受け渡しながら検索実行、検索結果モーダルを表示
 * 給湯・温水暖房一体型検索時 ... 給湯・温水暖房一体型の検索である情報を受け渡しながら検索実行、検索結果モーダルを表示
 */
import help from "@/mixins/help"
import master from "@/mixins/master"
import device from '@/mixins/device'
import { mapGetters, mapActions } from 'vuex'
import { mapComputedProperties } from '@/util'

export default {
    name:"PageManualHotWaterSystem",
    computed: {
        ...mapGetters({
            data:'data/getData',
            hybridwaterheaterSenyoFilter:'data/getHybridwaterheaterSenyoFilter',
            hybridwaterheaterIttaiFilter:'data/getHybridwaterheaterIttaiFilter',
            hwSenyoSelected:'search/getSelectedHWSenyo',
            hwIttaiSelected:'search/getSelectedHWIttai',
            electricHeatPumpSelected:'search/getSelectedElectricHeatPump',
        }),
        ...mapComputedProperties([
            'hw_setti',
            'hw_shurui_s',
            'hw_senyo_sr1_taisaku',
            'hw_senyo_sr1_e',
            'hw_senyo_sr1_emode',
            'hw_src_type',
            'hw_senyo_sr2_taisaku',
            'hw_senyo_sr2_e',
            'hw_senyo_sr2_emode',
            'hw_senyo_sr3_taisaku',
            'hw_senyo_sr3_e',
            'hw_senyo_sr3_emode',
            'hw_senyo_sr4_taisaku',
            'hw_senyo_sr4_e',
            'hw_senyo_sr4_emode',
            'hw_senyo_sr6_spec_method',
            'hw_senyo_sr6_taisaku',
            'hw_senyo_sr6_e',
            'hw_senyo_sr6_m1see',
            'hw_senyo_sr6_name',            
            'hw_senyo_sr6_P_HP_imd_std',
            'hw_senyo_sr6_P_HP_sum_std',
            'hw_senyo_sr6_P_HP_win_std',
            'hw_senyo_sr6_q_HP_imd_std',
            'hw_senyo_sr6_q_HP_sum_std',
            'hw_senyo_sr6_q_HP_win_std',
            'hw_senyo_sr6_e_HP_def_high',
            'hw_senyo_sr6_e_HP_frst_high',
            'hw_senyo_sr6_theta_bw_frst_high',
            'hw_senyo_sr6_theta_bw_imd_std',
            'hw_senyo_sr6_theta_bw_sum_std',
            'hw_senyo_sr6_theta_bw_win_std',
            'hw_senyo_sr6_A_p',
            'hw_senyo_sr6_B_p',
            'hw_senyo_sr6_P_aux_HP_on',
            'hw_senyo_sr6_P_aux_HP_off',
            'hw_senyo_sr6_Q_loss',
            'hw_senyo_sr6_R_tnk',
            'hw_senyo_sr6_theta_hat_bw_win_cm_first',
            'hw_senyo_sr6_theta_hat_bw_win_cm_second',
            'hw_senyo_sr7_package_input',
            'hw_senyo_sr7_coolant_type',
            'hw_senyo_sr7_tank',
            'hw_ittai_sr11_taisaku',
            'hw_ittai_sr11_heater_e',
            'hw_ittai_sr11_hotwater_e',
            'hw_ittai_sr11_hotwater_emode',
            'hw_ittai_sr12_taisaku',
            'hw_ittai_sr12_heater_e',
            'hw_ittai_sr12_hotwater_e',
            'hw_ittai_sr12_hotwater_emode',
            'hw_ittai_sr13_taisaku',
            'hw_ittai_sr13_heater_e',
            'hw_ittai_sr13_hotwater_e',
            'hw_ittai_sr13_hotwater_emode',
            'hw_ittai_sr14_taisaku',
            'hw_ittai_sr14_hotwater_e',
            'hw_ittai_sr14_hotwater_emode',
            'hw_ittai_sr16_tank',
            'hw_ittai_sr17_kubun',
            'hw_ittai_sr18_package_input',
            'hw_ittai_sr18_coolant_type',
            'hw_ittai_sr18_tank',
            'hw_hybrid_a_HP',
            'hw_hybrid_b_HP',
            'hw_hybrid_a_TU',
            'hw_hybrid_b_TU',
            'hw_hybrid_eta_loss_TU',
            'hw_hybrid_e_BB_jis',
            'hw_hybrid_e_HPstd_m7',
            'hw_hybrid_e_HPstd_2',
            'hw_hybrid_e_HPstd_7',
            'hw_hybrid_e_HPstd_25',
            'hw_hybrid_Q_HP_max',
            'hw_hybrid_theta_ex_min_HP',
            'hw_hybrid_R_day',
            'hw_other_name',
            'hw_header_type',
            'hw_pipesize',
            'hw_daidokoro_suisen',
            'hw_daidokoro_temoto',
            'hw_daidokoro_yusen',
            'hw_shower_suisen',
            'hw_shower_temoto',
            'hw_shower_shoryuryo',
            'hw_senmen_suisen',
            'hw_senmen_yusen',
            'hw_yokuso_hoon',
            'hybridwaterheater_senyo_filter',
            'hybridwaterheater_ittai_filter',
            'electricHeatPumpFilter',
        ]),
        isBath(){
            const shuruiArray=['1', '2', '3', '4', '5', '6', '11', '12', '13', '14', '15', '21', '22']
            return this.hw_setti != 3 && shuruiArray.includes(this.hw_shurui_s)
        }
    },
    mixins:[help, master, device],
    methods:{
        ...mapActions({
            update:'data/update',
            setResult:'search/setResult',
            searchResultVisible:'view/searchResultShow',
        }),
        /**
         * 給湯専用型の検索
         */
        searchHybridWaterHeaterSenyo: async function(){
            this.searchHybridWaterHeaterItem(this.hybridwaterheater_senyo_filter, 'hw_senyo')
        },
        /**
         * 給湯・温水暖房一体型の検索
         */
        searchHybridWaterHeaterIttai: async function(){
            this.searchHybridWaterHeaterItem(this.hybridwaterheater_ittai_filter, 'hw_ittai')
        },
        /**
         * 電気ヒートポンプの検索
         */
        searchElectricHeatPumpPackage: async function(){
            this.searchElectricHeatPump(this.electricHeatPumpFilter)
                .then(data => {
                    this.setResult({value:this.electricHeatPumpFilter, result:data, type:'electricHeatPump'})
                    this.searchResultVisible()
                })
        },
        /**
         * 給湯機器検索の共通処理
         */
        searchHybridWaterHeaterItem: async function(value, type){
            this.searchHybridWaterHeater(value)
                .then(data => {
                    this.setResult({value:value, result:data, type:type})
                    this.searchResultVisible()
                })
        },
    }
}
</script>

<style scoped>
.package_id >>> .grid_2{
    flex-flow: row wrap;
}
.hundred_percent{
    display: block;
    width:100%;
}
.flex_column >>> .radio_sub_box .label{
    min-width:9em;
}
.param >>> .grid_2 label{
    display: inline-block;
    width: 9em;
}
.wrapper >>> .information a.target_blank.alink_disabled{
  pointer-events: none;
  color: #aaa;
}
</style>
